module.exports = __webpack_public_path__ + "img/curve_4@2x.16954353.png";